import { render } from "./SimilarResultsToggle.vue?vue&type=template&id=6f57c2db&scoped=true"
import script from "./SimilarResultsToggle.vue?vue&type=script&lang=js"
export * from "./SimilarResultsToggle.vue?vue&type=script&lang=js"

import "./SimilarResultsToggle.vue?vue&type=style&index=0&id=6f57c2db&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f57c2db"]])

export default __exports__